// frontend/src/components/layout/Layout.js
//
// App shell: header, outlet (page content), bottom nav.
// No data fetching. Reads theme from SettingsStore via hook.

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useSetting } from '../../hooks/useSettings';
import VakyaLogo from './VakyaLogo';
import styles from './Layout.module.css';

const NAV_ITEMS = [
  { path: '/',         label: 'Home',     icon: '⌂' },
  { path: '/search',   label: 'Search',   icon: '⌕' },
  { path: '/browse',   label: 'Browse',   icon: '⊞' },
  { path: '/settings', label: 'Settings', icon: '⚙' },
  { path: '/admin',    label: 'Admin',    icon: '⊛' },
  { path: '/corpus',   label: 'Corpus',   icon: '❧' },
];

export default function Layout() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const [theme]   = useSetting('theme');

  return (
    <div className={styles.shell} data-theme={theme === 'system' ? undefined : theme}>
      <header className={styles.header}>
        <button
          className={styles.brandBtn}
          onClick={() => navigate('/')}
          aria-label="Go to home"
        >
          <VakyaLogo size={36} />
          <div className={styles.brandText}>
            <span className={styles.brandDeva}>महावाक्य</span>
            <span className={styles.brandSub}>Classical Literature Search</span>
          </div>
        </button>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <nav className={styles.bottomNav} aria-label="Main navigation">
        {NAV_ITEMS.map(item => {
          const active = item.path === '/'
            ? location.pathname === '/'
            : location.pathname.startsWith(item.path);
          return (
            <button
              key={item.path}
              className={`${styles.navItem} ${active ? styles.navItemActive : ''}`}
              onClick={() => navigate(item.path)}
              aria-current={active ? 'page' : undefined}
              aria-label={item.label}
            >
              <span className={styles.navIcon}>{item.icon}</span>
              <span className={styles.navLabel}>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
